import { gql } from '@apollo/client';
import { VersionHistoryFields } from 'ants/query';

export const WebsiteCreateHintQuery = gql`
query WebsiteCreateHintQuery($name: String!) {
  cms_website_create_hint(name: $name) {
    name
    similar_items {
      resource {
        account
        website
        hashkey: _hashkey
      }
      name {
        name
      }
    }
    key_suggestions
  }
}
`;

export const WebsiteCreateMutation = gql`
mutation WebsiteCreate(
  $website: WebsiteWebsiteInput!,
  $key: String,
) {
  cms_website_create(
    website: $website,
    key: $key) {
      status {
      okay
      errors {
        msg
        field_path
        code
      }
      key
    }
  }
}
`;

export const WebsiteReadQuery = gql`
query WebsiteReadQuery($resource: WebsiteInput!, $withHistory: Boolean) {
  cms_website_read(resource: $resource, with_history: $withHistory) {
    item {
      resource {
        account
        website
        hashkey: _hashkey
      }
      name { name }
      website {
        name
        url
        is_default
        variables {name, value}
        options {name, value { name, value }}
      }
    }
    history {
      ${VersionHistoryFields}
    }
  }
}
`;

export const WebsiteUpdateMutation = gql`
mutation WebsiteUpdateMutation(
  $resource: WebsiteInput!,
  $website: WebsiteWebsiteInput!,
  $version: RecordStage) {
  cms_website_update(
    resource: $resource,
    website: $website,
    version: $version,
  ) {
    status {
      okay
      errors {
        msg
        field_path
        code
      }
      key
    }
  }
}
`;

export const WebsiteDeleteMutation = gql`
mutation  WebsiteDeleteMutation(
  $resource: WebsiteInput!,
  $name: String!) {
  cms_website_delete(resource: $resource, name: $name) {
    status {
      okay
      errors { msg, field_path, code}
      key
    }
  }
}
`;

export const WebsiteSearchQuery = gql`
query WebsiteSearchQuery($search: String!, $page: PagedRequestInput) {
  cms_website_search(search: $search, page: $page) {
    items {
      resource {
        account
        website
        hashkey: _hashkey
      }
      name {
        name
      }
    }
    page {
      next_page_key
      count
      prev_page_key
    }
  }
}
`;

export const WebsiteNameQuery = gql`
query WebsiteNameQuery($resource: WebsiteInput!) {
  cms_website_name(resource: $resource) {
    name
  }
}
`;
